






















































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import moment from "moment";
import CurrentHoldingsChart from "@/shared/components/investments/drivewealth/CurrentHoldingsChart.vue";
import AdvisoryFunds from "@/shared/components/investments/drivewealth/AdvisoryFunds.vue";
import CurrentHoldingsTable from "@/shared/components/investments/drivewealth/CurrentHoldingsTable.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import InvestWithDrivewealthWidget from "@/employee/components/investments/drivewealth/InvestWithDrivewealthWidget.vue";
import PreenrollmentWidget from "@/employee/components/investments/drivewealth/PreenrollmentWidget.vue";
import SweepCallToAction from "@/shared/components/investments/drivewealth/SweepCallToAction.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import UserPartnerContent from "@/employee/components/investments/drivewealth/UserPartnerContent.vue";
import PreenrollmentManagement from "@/shared/components/investments/drivewealth/PreenrollmentManagement.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import HsabInvestmentAccountRedirectLink from "@/shared/components/investments/HsabInvestmentAccountRedirectLink.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { useRiskToleranceQuestionnaireStore } from "@/shared/store/riskToleranceQuestionnaire";
import { DrivewealthWizardStep, DrivewealthAccountManagementType } from "@/shared/types";
import * as Routes from "@/employee/route-names";
import * as SharedRoutes from "@/shared/route-names";

@Component({
  components: {
    DrivewealthNavigation,
    CurrentHoldingsTable,
    AdvisoryFunds,
    CurrentHoldingsChart,
    GenericLoadingSpinner,
    InvestWithDrivewealthWidget,
    SweepCallToAction,
    RiskDisclaimer,
    UserPartnerContent,
    PreenrollmentWidget,
    PreenrollmentManagement,
    AccountTypeSubheader,
    HsabInvestmentAccountRedirectLink,
  }
})
export default class DrivewealthInvestmentPage extends Vue {
  drivewealthStore = useDrivewealthStore();
  drivewealthSweepStore = useDrivewealthSweepStore();
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  featureFlagStore = useFeatureFlagStore();
  signingDocumentStore = useSigningDocumentStore();
  custodianSettingsStore = useCustodianSettingsStore();
  investmentThresholdStore = useInvestmentThresholdStore();

  DrivewealthAccountManagementType = DrivewealthAccountManagementType;
  Routes = Routes;
  finishedCheckingAccountClaims = false;

  @Prop() accountId: number;
  @Prop() force: boolean;

  @Watch("drivewealthWizardStore.isPreenrolled")
  load (): void {
    this.investmentDailyBalanceStore.loadHsaBalanceAndThreshold({ force: this.force });
    if (this.accountId) {
      this.drivewealthSweepStore.getSweepV2({});
    } else {
      this.drivewealthSweepStore.getSweep({});
    }
    this.drivewealthWizardStore.loadExistingPreenrollment({});
    this.drivewealthWizardStore.loadAllowedInvestmentAccountTypes({});
    this.drivewealthStore.loadAccountClaims({});
    if (this.custodianSettingsStore.isHsaBankCustodian) {
      this.signingDocumentStore.getHsabDrivewealthAccountSignature();
    }
    this.drivewealthStore.loadAccountSummariesV2({});
  }

  @Watch("accountId")
  reload (): void {
    this.load();
  }

  mounted (): void {
    this.load();
  }

  get displayAccountPerformanceComponent (): boolean {
    return !!this.$route.query.spd;
  }

  onClose () {
    this.drivewealthStore.setShowModal(false);
  }

  get showModal () {
    const cutoffDate = moment("04/28/2025");
    const dateNow = moment();
    const isBeforeCutoffDate = dateNow.isBefore(cutoffDate);
    const account = this.drivewealthStore.accountSummariesV2.find(e => e.drivewealthAccountId === this.accountId);
    return this.featureFlagStore.flags.bend22421ShowMessageForSelect &&
        this.drivewealthStore.accountManagementType(this.accountId) === DrivewealthAccountManagementType.Advisory &&
        account.isCuratedRtqAccountType === true && this.drivewealthStore.showModal &&
        isBeforeCutoffDate;
  }

  get accountManagementType (): DrivewealthAccountManagementType {
    if (this.drivewealthWizardStore.isPreenrolled) {
      return this.drivewealthWizardStore.enrollmentAccountType;
    }

    return this.drivewealthStore.accountManagementType(this.accountId);
  }

  get displayRiskToleranceQuestionnaireLink (): boolean {
    return this.accountManagementType === DrivewealthAccountManagementType.RiaManaged;
  }

  get showLoadingSpinner (): boolean {
    return !this.isLoaded && !this.finishedCheckingAccountClaims;
  }

  get isLoaded (): boolean {
    const isLoaded = this.investmentDailyBalanceStore.isHsaBalanceAndThresholdLoaded &&
      this.drivewealthSweepStore.sweepLoaded &&
      this.drivewealthStore.isAccountClaimsLoaded;

    if (isLoaded) {
      this.redirectIfMissingAccountClaims();
    }
    return isLoaded;
  }

  get showPreenrollment (): boolean {
    // only shown in UI (via v-if) when: this.isLoaded && !this.hasAnAccount && !this.isPreenrolled
    return !this.investmentDailyBalanceStore.hasEnoughToOpenAccount &&
      this.drivewealthWizardStore.isAllowedToPreenroll;
  }

  redirectIfMissingAccountClaims (): void {
    if (this.drivewealthStore.isAccountClaimsLoaded) {
      const accountIdToUse = this.accountId;
      const accountClaim = this.drivewealthStore.accountClaims.find(c => c.drivewealthApiAccountId === accountIdToUse);
      if (accountClaim && accountClaim.isClaimed === false) {

        const hsabEsignRequired = this.custodianSettingsStore.isHsaBankCustodian && !this.signingDocumentStore.hsabDrivewealthAccountSignatureIsSigned;

        if (hsabEsignRequired) {
          this.$router.replace({ name: SharedRoutes.DrivewealthHsabAccountSignature,
            params: { accountId: `${accountIdToUse}` },
            query: { redirectRoute: Routes.DrivewealthInvestmentAccountClaims } });
        } else {
          this.$router.replace({ name: Routes.DrivewealthInvestmentAccountClaims,
            params: { step: DrivewealthWizardStep.RequiredDisclosures} });
        }
      }
      this.finishedCheckingAccountClaims = true;
    }
  }
}
